import script from "./TokenSelectCard.vue?vue&type=script&lang=ts&setup=true"
export * from "./TokenSelectCard.vue?vue&type=script&lang=ts&setup=true"

import "./TokenSelectCard.vue?vue&type=style&index=0&id=104cebc0&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/curl-fe-build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-104cebc0"]])

export default __exports__